<template>
    <v-card flat class="d-flex layout-auth-root" :class="($vuetify.breakpoint.mdAndUp) ? 'flex-row' : 'flex-column'">
        <v-card v-if="$vuetify.breakpoint.mdAndUp" max-width="50%" width="50%" color="grey darken-2"
            class="rounded-0 layout-auth-side" style="position: relative;">
            <v-img src="@/assets/login/Img-login-1.png" height="100vh" width="100%"
                style="object-fit: cover;" />
            <FabRedesSociales :horizontal="true"></FabRedesSociales>
        </v-card>
        <v-card :max-width="($vuetify.breakpoint.smAndDown) ? '100%' : '50%'" width="100%"
            class="d-flex flex-row justify-center layout-auth-content"
            :class="$vuetify.breakpoint.mdAndUp ? 'align-center' : 'align-start pt-4'" flat>
            <v-card flat
                :class="($vuetify.breakpoint.mdAndUp) ? 'justify-center' : 'flex-column justify-center'">
                <v-card-text :class="($vuetify.breakpoint.mdAndUp) ? 'd-flex justify-center my-5' : 'my-0'">
                    <v-img v-if="$vuetify.breakpoint.mdAndUp" max-width="275px" src="@/assets/Logo-bt-07.png" contain
                        :style="logoClickable ? 'cursor: pointer;' : ''" @click="onLogoClick" />
                </v-card-text>
                <slot />
                <div class="text-center mt-4 mb-2">
                    <v-chip x-small label outlined color="grey">
                        v{{ version }}<span v-if="fechaFormateada" class="mx-1">·</span>{{ fechaFormateada }}
                    </v-chip>
                </div>
            </v-card>
        </v-card>
    </v-card>
</template>

<script>
import FabRedesSociales from '@/components/fabs/FabRedesSociales.vue';

export default {
    name: 'LayoutAuth',
    components: {
        FabRedesSociales,
    },
    props: {
        logoClickable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            version: process.env.VUE_APP_VERSION || 'dev',
            fechaVersion: process.env.VUE_APP_VERSION_FECHA || '',
        };
    },
    computed: {
        // Convierte la fecha ISO del version.json (YYYY-MM-DD) a DD/MM/YYYY.
        fechaFormateada() {
            if (!this.fechaVersion) return '';
            const partes = this.fechaVersion.split('-');
            if (partes.length === 3) return `${partes[2]}/${partes[1]}/${partes[0]}`;
            return this.fechaVersion;
        },
    },
    methods: {
        onLogoClick() {
            if (this.logoClickable) {
                this.$emit('logoClick');
            }
        },
    },
};
</script>

<style scoped>
/* En desktop el layout es row y el viewport completo es para LayoutAuth.
   Fijamos 100vh para que la imagen lateral coincida con el viewport y no
   deje espacio vacío debajo cuando el slot del form crece. El scroll del
   lado derecho queda interno y no rompe el layout.

   En mobile NO fijamos altura: NavLogin ocupa 140px arriba (app-bar) y el
   form fluye natural debajo. Si el contenido excede, scrollea el documento. */
@media (min-width: 960px) {
    .layout-auth-root {
        height: 100vh;
        overflow: hidden;
    }
    .layout-auth-side {
        height: 100vh;
        overflow: hidden;
    }
    .layout-auth-content {
        height: 100vh;
        overflow-y: auto;
    }
}
</style>
